<template>
  <div>
    <b-modal
      id="view-record-modal"
      title="View Vehicle Record"
      header-bg-variant="success"
      centered
      hide-footer
      :scrollable="true">
      <b-row>
        <b-col sm="6">
          <b-form-group label="Vehicle ID" label-class="font-weight-bold">
            <span>{{ item.vehicleId }}</span>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="License Plate" label-class="font-weight-bold">
            <span>{{ item.licensePlate }}</span>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Current State" label-class="font-weight-bold">
            <span>{{ item.currentState }}</span>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Vehicle Owner" label-class="font-weight-bold">
            <span>{{ item.vehicleOwner }}</span>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Make" label-class="font-weight-bold">
            <span>{{ item.make }}</span>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Model" label-class="font-weight-bold">
            <span>{{ item.model }}</span>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Colour" label-class="font-weight-bold">
            <span>{{ item.colour }}</span>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Registration Date" label-class="font-weight-bold">
            <span>{{ item.registrationDate | date('YYYY-MM-DD') }}</span>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Chasis Number" label-class="font-weight-bold">
            <span>{{ item.chasisNumber }}</span>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Engine Number" label-class="font-weight-bold">
            <span>{{ item.engineNumber }}</span>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="IU Number" label-class="font-weight-bold">
            <span>{{ item.iuNumber }}</span>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="ARF Paid" label-class="font-weight-bold">
            <span>{{ item.arfPaid || '-' }}</span>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="COE Paid" label-class="font-weight-bold">
            <span>{{ item.coePaid || '-' }}</span>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Road Tax Amount" label-class="font-weight-bold">
            <span>{{ item.roadTaxAmount || '-' }}</span>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Next Road Tax Renewal" label-class="font-weight-bold">
            <span>{{ item.nextRoadTaxRenewal || '-' }}</span>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Insurance Cover by" label-class="font-weight-bold">
            <span>{{ item.insuranceCoverBy || '-' }}</span>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Insurance Premium" label-class="font-weight-bold">
            <span>{{ item.insurancePremium || '-' }}</span>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Insurance Certificate" label-class="font-weight-bold">
            <span v-if="!item.insuranceCertificate.length">N/A</span>
            <div
              v-for="certificate in item.insuranceCertificate"
              :key="certificate.fileName"
              class="input-group mb-2">
              <a 
                :href="certificate.fileUrl" 
                target="_blank">
                {{ certificate.fileName }}
              </a>
            </div>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Next Premium Renewal Date" label-class="font-weight-bold">
            <span>{{ item.nextPremiumRenewalDate || '-' }}</span>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Date Sold" label-class="font-weight-bold">
            <span>{{ item.dateSold || '-' }}</span>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Selling Price" label-class="font-weight-bold">
            <span>{{ item.sellingPrice || '-' }}</span>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Purchaser's Name" label-class="font-weight-bold">
            <span>{{ item.purchaserName || '-' }}</span>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Category" label-class="font-weight-bold">
            <span>{{ item.category || '-' }}</span>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Current Station" label-class="font-weight-bold">
            <span>{{ item.currentStation || '-' }}</span>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Date Started at Current Station" label-class="font-weight-bold">
            <span>{{ dateStartedStation }}</span>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="iBoxx Label No" label-class="font-weight-bold">
            <span>{{ item.iBoxxLabelNo || '-' }}</span>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="iBox QNR" label-class="font-weight-bold">
            <span>{{ item.iBoxQnr|| '-' }}</span>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="iBox Version" label-class="font-weight-bold">
            <span>{{ item.iBoxxVersion || '-' }}</span>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="SIM" label-class="font-weight-bold">
            <span>{{ item.sim || '-' }}</span>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Telco" label-class="font-weight-bold">
            <span>{{ item.telco || '-' }}</span>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Remark / Notes" label-class="font-weight-bold">
            <span>{{ item.remark || '-' }}</span>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  name: 'VehicleRecordModal',
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    dateStartedStation () {
      if (!this.item.dateStartedCurrentStation) return '-'
      return moment(this.item.dateStartedCurrentStation).utcOffset(8).format('DD-MM-YYYY')
    }
  }
}
</script>